module.exports = __webpack_public_path__ + "static/media/moreOption.720faceb.svg";